const UCI_SITEMAPS = [
  {
    title: 'Used Makes For Sale',
    location: '/uci-make-sitemap.html',
  },
  {
    title: 'Used Make Models For Sale',
    location: '/uci-make-model-sitemap.html',
  },
  {
    title: 'Used Make Model Years For Sale',
    location: '/uci-year-location.html',
  },
  {
    title: 'Used Vehicle Types For Sale',
    location: '/uci-type.html',
  },
  {
    title: 'Used Vehicle Under Price For Sale',
    location: '/uci-price-under-sitemap.html',
  },
];

const DATA_MAPPING = {
  '/uci-sitemaps.html': UCI_SITEMAPS,
};

export function getStaticSitemapData(pathname) {
  return DATA_MAPPING[pathname] || [];
}
